import {useEvoContext} from "../../context/evo.context";
import Cookies from "js-cookie";
import {
    Avatar,
    Box,
    Button,
    Center,
    Flex,
    Image, Link,
    Menu,
    MenuButton,
    MenuDivider, MenuItem,
    MenuList,
    Stack,
    useBreakpointValue,
    IconButton
} from "@chakra-ui/react";
import React from "react";

import { HamburgerIcon } from '@chakra-ui/icons';
import {ROUTE_MAIN, ROUTE_PROFILE, ROUTE_LOGIN, ROUTE_PURCHASE, ROUTE_PARAM_ISSUE} from "../../App";
import {useNavigate} from "react-router-dom";

export function Header() {

    const {isLoggedIn, userData, setLogout, hasSubscriptionActive} = useEvoContext();
    const isMobile = useBreakpointValue({ base: true, md: false });
    const navigate = useNavigate();


    const handleLogout = (event: any) => {
        event.preventDefault(); // Prevents the default link behavior
        setLogout();
        navigate(ROUTE_MAIN);
    };

    return (
        <>
            <Box bg={"white"} px={4} boxShadow={"sm"}>
                <Flex h={16} alignItems={'center'} justifyContent={'space-between'}>
                    <Flex flexDirection={"row"} columnGap={"10px"} alignItems={'center'} justifyContent={'space-between'}>
                        <a href={"/"}>
                            <Image
                                alt={'Login Image'}
                                objectFit={'cover'}
                                src={
                                    '/logo.svg'
                                }
                            />
                        </a><a href={"/"} >Vinařský obzor</a>
                    </Flex>
                    <Flex alignItems={'center'}>
                        {!isMobile && ( <Stack direction={'row'} spacing={7}>
                            {/*<Button colorScheme='pink' variant='solid'>*/}
                            {/*    <a href={"aktivace"}>Aktivovat kód</a>*/}
                            {/*</Button>*/}

                            {!hasSubscriptionActive && (<Button  as="a" href={ROUTE_MAIN + ROUTE_PURCHASE} colorScheme='pink' variant='solid'>
                               {"Koupit předplatné"}
                            </Button>)}
                            {!isLoggedIn && (<Button as="a" href={ROUTE_MAIN + ROUTE_LOGIN} colorScheme='pink' variant='outline'>
                                {"Přihlásit se"}
                            </Button>)}
                            <Menu>
                                <MenuButton
                                    as={Button}
                                    rounded={'full'}
                                    variant={'link'}
                                    cursor={'pointer'}
                                    minW={0}>
                                    <Avatar
                                        size={'sm'}
                                        src={'/images/userProfile.jpg'}
                                    />
                                </MenuButton>
                                <MenuList alignItems={'center'}>
                                    <br />
                                    <Center>
                                        <Avatar
                                            size={'2xl'}
                                            src={'/images/userProfile.jpg'}
                                        />
                                    </Center>
                                    <br />
                                    {isLoggedIn && <Center>
                                        {(Object.keys(userData).length > 0 && 'name' in userData) && <p>{userData.name}</p>}
                                    </Center>}
                                    <br />
                                    <MenuDivider />
                                    <Flex direction={"column"} justifyContent={"center"}>
                                        {isLoggedIn && <MenuItem justifyContent={"center"}><Link href={ROUTE_MAIN + ROUTE_PROFILE}>{"Moje předplatné"}</Link></MenuItem>}
                                        {isLoggedIn && <MenuItem justifyContent={"center"}><Link href={"#"} onClick={handleLogout}>Odhlásit se</Link></MenuItem>}
                                        {!isLoggedIn && <MenuItem justifyContent={"center"}><Link href={ROUTE_MAIN + ROUTE_LOGIN}>Přihlásit se</Link></MenuItem>}
                                    </Flex>
                                </MenuList>
                            </Menu>
                        </Stack>)}

                        {isMobile && (
                            <Menu>
                                <MenuButton
                                    as={IconButton}
                                    aria-label="Options"
                                    icon={<HamburgerIcon />}
                                    variant="outline"
                                />
                                <MenuList>
                                    {/*<MenuItem>*/}
                                    {/*    <Link href={"aktivace"}>Aktivovat kód</Link>*/}
                                    {/*</MenuItem>*/}
                                    {!hasSubscriptionActive && (<MenuItem justifyContent={"center"}>
                                        <Link href={ROUTE_MAIN + ROUTE_PURCHASE}>Koupit předplatné</Link>
                                    </MenuItem>)}
                                    {!isLoggedIn && (
                                        <MenuItem justifyContent={"center"}>
                                            <Link href={ROUTE_MAIN + ROUTE_LOGIN}>Přihlásit se</Link>
                                        </MenuItem>
                                    )}
                                    {isLoggedIn && (
                                        <>
                                            <MenuDivider />
                                            <MenuItem justifyContent={"center"}>
                                                <Link href={ROUTE_MAIN + ROUTE_PROFILE}>{"Moje předplatné"}</Link>
                                            </MenuItem>
                                            <MenuItem justifyContent={"center"}>
                                                <Link href={"#"} onClick={handleLogout}>Odhlásit se</Link>
                                            </MenuItem>
                                        </>
                                    )}
                                </MenuList>
                            </Menu>
                        )}
                    </Flex>
                </Flex>
            </Box>
        </>
    )

}
